import React from "react";

function NonAuthLayout(props) {
  return <React.Fragment>{props.children}</React.Fragment>;
}

export default NonAuthLayout;
